import { fromHttpPromise } from 'pulse/adapters';
import { persistedTypeMetadataPromise, recombineAppSettingTypeMap, keyEntriesByFQN } from 'fdsr-migration-layer';
import { batchScheduler } from 'batch-promise';
import { extractAppSetting, consumeEarlyAppSettings } from './early';
const scheduler = batchScheduler().read().identity(({
  appSettingName
}) => appSettingName).partition(() => 'appSettings').execute(async calls => {
  const callsArray = Object.values(calls);
  const httpClient = callsArray[0].httpClient;
  const appSettingNames = callsArray.map(c => c.appSettingName);
  const results = await Promise.allSettled(appSettingNames.map(appSettingName => persistedTypeMetadataPromise.makeFetchWithOpts({
    refresh: true
  })({
    appSettingName,
    httpClient
  })));
  if (results[0].status === 'rejected' && results.every(result => result.status === 'rejected')) {
    throw results[0].reason;
  }
  return keyEntriesByFQN(recombineAppSettingTypeMap(results, appSettingNames));
}).extract(extractAppSetting).immediate();
const fetchAppSetting = (httpClient, params) => consumeEarlyAppSettings(params).catch(() => scheduler.queue(Object.assign({
  httpClient
}, params)));
export const defaultAppSettingsResolver = fromHttpPromise('appSettingsResolver', fetchAppSetting);
export const __TEST_ONLY_abortAppSettingsScheduler = () => scheduler.abort();